import fquery from './fquery'
import storage from './storage'
import urlEncode from './url-encode'
import errorCode from './error-code'
import getCanvasSize from './get-canvas-size'
import thirdAuth from './third-auth'
import setJsSdkUrl from './set-js-sdk-url'

export default {
  fquery,
  storage,
  urlEncode,
  errorCode,
  getCanvasSize,
  thirdAuth,
  setJsSdkUrl,
}
